import { privateFetch, readPrivacyResponse, validateConsentState } from './privateTransport';

// Written only after an explicit withdrawal; contains a short-lived session
// credential so an offline revocation can be retried without sending content.
const KEY='meetjoz-pending-cloud-withdrawal-v3';
export function rememberWithdrawal(session,purposes=[],version) {
  if(!session?.token||!purposes.length) return;
  try {
    const previous=JSON.parse(localStorage.getItem(KEY)||'null');
    const merged=previous?.token===session.token?[...new Set([...previous.purposes,...purposes])]:purposes;
    localStorage.setItem(KEY,JSON.stringify({authority:session.authority,token:session.token,expiresAt:session.expiresAt,purposes:merged,version,requestId:crypto.randomUUID()}));
  } catch {}
}
export function forgetWithdrawal(purposes, expected) {
  try {
    const stored=JSON.parse(localStorage.getItem(KEY)||'null');
    if(expected&&(stored?.token!==expected.token||(expected.requestId!==undefined&&stored?.requestId!==expected.requestId)))return;
    if(!purposes) {localStorage.removeItem(KEY);return;}
    const item=JSON.parse(localStorage.getItem(KEY)||'null');
    if(!item)return;
    const remaining=(item.purposes||[]).filter(purpose=>!purposes.includes(purpose));
    if(remaining.length)localStorage.setItem(KEY,JSON.stringify({...item,purposes:remaining}));
    else localStorage.removeItem(KEY);
  } catch {}
}
export async function retryWithdrawal(authority, fallbackVersion) {
  let item;try{item=JSON.parse(localStorage.getItem(KEY)||'null');}catch{return false;}
  if(!item)return false;
  if(typeof item.token!=='string'||!item.token||!Array.isArray(item.purposes)||!item.purposes.length||!Number.isFinite(Date.parse(item.expiresAt))){forgetWithdrawal(undefined,item);return false;}
  const expired=()=>({ok:true,token:item.token,scopes:{chat:false,voice:false,scene:false,assessment:false,contact:false,ar:false,review:false},expired:true});
  if(Date.parse(item.expiresAt)<=Date.now()){forgetWithdrawal(undefined,item);return expired();}
  if(item.authority!==authority)return false;
  const headers={'Content-Type':'application/json','X-Privacy-Session':item.token};
  const response=await privateFetch(`${authority}/api/privacy/consent`,{headers});
  if(response.status===401){forgetWithdrawal(undefined,item);return expired();}
  if(!response.ok)throw new Error('Server withdrawal is still pending');
  const current=validateConsentState(await readPrivacyResponse(response));
  let finalState=current;
  let finalScopes=current.scopes;
  // A grant request with a lost response might not have committed yet. Always
  // record the withdrawal to advance the revision and invalidate that grant.
  const purposes=item.purposes.filter(purpose=>['si_chat','voice_actions','scene_descriptions','business_assessment','contact_requests','ar_handoffs','saved_chat_review'].includes(purpose));
  if(purposes.length){
    const result=await privateFetch(`${authority}/api/privacy/consent/withdraw`,{method:'POST',headers,body:JSON.stringify({choices:purposes.map(purpose=>({purpose,choice:'withdrawn',idempotencyKey:crypto.randomUUID()})),noticeVersion:current.noticeVersion||fallbackVersion,expectedRevision:current.revision})});
    if(!result.ok)throw new Error('Server withdrawal is still pending');
    finalState=validateConsentState(await readPrivacyResponse(result));
    finalScopes=finalState.scopes;
    if(purposes.some(purpose=>finalScopes[({si_chat:'chat',voice_actions:'voice',scene_descriptions:'scene',business_assessment:'assessment',contact_requests:'contact',ar_handoffs:'ar',saved_chat_review:'review'})[purpose]]===true))throw new Error('Server withdrawal is still pending');
  }
  forgetWithdrawal(undefined,item);return {...finalState,ok:true,scopes:finalScopes,token:item.token};
}
